var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Layout"},[_c('AgencyHeader'),_vm._v(" "),_c('Content',{staticClass:"Layout__Content"},[_c('template',{slot:"content"},[_c('Nuxt')],1)],2),_vm._v(" "),_c('AppLoading'),_vm._v(" "),_c('ErrorDialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }